import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { cloneElement } from 'react';
import PropTypes from 'prop-types';
import { Label } from 'semantic-ui-react';
import classnames from 'classnames/bind';
import FieldTooltip from './fieldTooltip';
import FieldLabel from './fieldLabel';
import CheckboxLabel from './checkboxLabel';
import SubLabel from './subLabel';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const StandardFieldLabel = ({ label, subLabel, checkboxType, compact = false, hideLabel = false, showAnchor = false, showErrorAbove, helpContent, error, warning, inputName, required, fieldFocused, elmId, className, pendingApproval, tooltipIconStyle, }) => {
    const fieldLabelProps = {
        label,
        className,
        elmId,
        inputName,
        error,
        required,
        pendingApproval,
    };
    const fieldTooltipProps = {
        label,
        helpContent,
        showError: showErrorAbove,
        error,
        showAnchor,
        elmId,
        iconStyle: tooltipIconStyle,
    };
    return checkboxType ? (_jsx(CheckboxLabel, { ...{
            label,
            subLabel,
            compact,
            elmId,
            checkboxType,
            showAnchor,
            helpContent,
        } })) : (_jsxs(_Fragment, { children: [_jsxs("div", { className: cx('label-tooltip-container', { compact }), children: [!hideLabel && _jsx(FieldLabel, { ...fieldLabelProps }), (showAnchor || showErrorAbove) && (_jsx(FieldTooltip, { ...fieldTooltipProps }))] }), _jsx(SubLabel, { label: subLabel, compact: compact }), warning && (_jsx(Label, { basic: true, className: `warning-label ${fieldFocused ? '' : 'hidden'}`, pointing: 'below', children: warning }))] }));
};
StandardFieldLabel.propTypes = {
    label: PropTypes.node.isRequired,
    subLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    checkboxType: PropTypes.oneOf(['checkbox', 'radio']),
    compact: PropTypes.bool,
    hideLabel: PropTypes.bool,
    showAnchor: PropTypes.bool,
    showErrorAbove: PropTypes.bool,
    helpContent: PropTypes.node,
    error: PropTypes.string,
    warning: PropTypes.string,
    inputName: PropTypes.string,
    required: PropTypes.bool,
    fieldFocused: PropTypes.bool,
    pendingApproval: PropTypes.bool,
    elmId: PropTypes.string,
    className: PropTypes.string,
    tooltipIconStyle: PropTypes.string,
};
StandardFieldLabel.createFromLabel = (label, labelProps) => label?.type?.createFromLabel ? (cloneElement(label, labelProps)) : (_jsx(StandardFieldLabel, { label: label, ...labelProps }));
export default StandardFieldLabel;
//# sourceMappingURL=standardFieldLabel.js.map